











import TableCell from './TableCell.vue'
import LoadWeightSpecification from './order-common/LoadWeightSpecification.vue'
import VehicleTypes from './order-common/VehicleTypes.vue'

export default {
  components: {
    TableCell,
    LoadWeightSpecification,
    VehicleTypes
  },
  props: {
    order: { type: Object, required: true },
    hSpan: { type: Number, default: 3 }
  }
}
